import { BrowserRouter } from "react-router-dom";
import Index from "./pages/Dashboard/Index";
import "../src/Assets/styles/style.scss";
import "../src/Assets/styles/Custom.css";
import "../src/Assets/styles/demo.css";
import "antd/dist/antd.min.css";

import "./App.css";
// context api
import { AppContext } from "./AppContext";
import AllRoutes from "./Routes/AllRoutes";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function App() {

    return (
        <div className="App">
            <AppContext>
                <BrowserRouter>
                    <ToastContainer
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="dark"
                    // transition:Bounce,
                    />
                    {/* All Dynamic Routes */}
                    <AllRoutes />

                </BrowserRouter>
            </AppContext>
        </div>
    );
}

export default App;
